<!-- eslint-disable -->
<template>
  <div class="multi-select">
    <rich-button class="multi-select-btn"
      @click="showPopup"
      icon="richic-select"
      outline>{{showValue}}</rich-button>
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'MultiSelect',
  components: {
  },
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    placeholder: {
      requried: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    negateValue: {
      required: false,
      type: [String, Number],
      default: undefined
    },
    fullScreen: {
      requried: false,
      type: Boolean,
      default: true
    },
    disabled: {
      requried: false,
      type: Boolean,
      default: false
    },
    zindex: {
      requried: false,
      type: Number,
      default: 50
    }
  },
  computed: {
    showValue () {
      // eslint-disable-next-line prefer-const
      let arr = this.value.map(val => {
        // eslint-disable-next-line prefer-const
        let target = this.options.find(i => i.value === val)
        return target ? target.label : '--'
      })
      return arr.length > 0 ? arr.join(',') : this.placeholder
    }
  },
  methods: {
    showPopup () {
      if (this.disabled) {
        return
      }
      const Select = this.$createFullScreenSelect({
        fullScreen: this.fullScreen,
        zindex: this.zindex,
        value: this.value,
        options: this.options,
        title: this.title,
        negateValue: this.negateValue
      }).show()
      Select.$on('confirm', (data) => {
        this.$emit('input', data)
      })
    }
  }
}
</script>

<!-- prettier-ignore -->
<style lang="scss" scoped>
.multi-select {
  overflow: auto;
  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }
}
</style>
